import { createStore } from "redux";

// cargamos nuestros reducers (ya combinados)
import reducers from "../reducers/reducers.js";

const store = createStore(reducers);
export default store;
